var OpportunityModalsModule = /** @class */ (function () {
    function OpportunityModalsModule() {
    }
    return OpportunityModalsModule;
}());
export { OpportunityModalsModule };
